/** Useful for deciding which keyboard shortcuts to use. */
export function isMac() {
  // Yes navigator.platform is deprecated, but it still seems like the best way to do this
  return navigator.platform.indexOf("Mac") === 0 || navigator.platform === "iPhone";
}

export function modKeyDisplay() {
  return isMac() ? "⌘" : "Ctrl";
}
